module.exports = __webpack_public_path__ + "static/media/task.d75f5f8e.png";